import axios from 'axios'
import Vue from 'vue'
import { EventBus } from "../complementos/event-bus.js";

const iplocal="//localhost:5005"
const ipServer="https://wpql.appiaco.cl/apislc/"
var urlApi; 


if (process.env.NODE_ENV === "production"){
    urlApi=ipServer; // ambiente api => produccion
} 
else{
 
   urlApi=ipServer;
}
 

const apSLC=axios.create({   baseURL: urlApi + "/", 
                                  headers: {
                                                Authorization:
                                                "Bearer " + "ASDasasdasdasd.1231233.ascasdasd" 
                                              }
                                });
var get=function(accion, parametro,loading=true){
                                    if(loading)EventBus.$emit("loading", true);
                                    return apSLC.get(accion +'/' + parametro )
                                                        .then(result => {
                                                            if(loading)EventBus.$emit("loading", false);
                                                                            return result.data})
                                                        .catch(ex =>{    if(loading)EventBus.$emit("loading", false);
                                                                        return ex})
                                    }
var post=function(accion, parametros,loading=true){
                                    if(loading) EventBus.$emit("loading", true);
                                        return apSLC.post(accion , parametros)
                                                            .then(result => {
                                                                if(loading)EventBus.$emit("loading", false);
                                                                                return result.data})
                                                            .catch(ex =>{        if(loading)EventBus.$emit("loading", false);
                                                                                return ex})
                                        }
export default
{
    get,
    post
}